import { useMutation, useQueryClient } from '@tanstack/react-query'
import { axios } from 'lib/axios'
import { ApiKey } from 'features/incidents/components/enums'
import { endpoints } from 'utils/endpoints'

export const changePolicy = (data: object) => {
  return axios.put(endpoints.changePolicy, data)
}
export const useChangePolicy = () => {
  const client = useQueryClient()
  return useMutation(changePolicy, {
    onSuccess: () => {
      client.invalidateQueries([ApiKey.policies, ApiKey.list])
      client.invalidateQueries([ApiKey.PreviousPolicies, ApiKey.list])
    },
  })
}
